import { ChangeEvent, FC } from "react";

import { GroupItem } from "@/model/UserCompanyConfiguration/GroupItem";

export interface IUserGroupSelect {
	OnChange: (e: ChangeEvent<HTMLSelectElement>) => void;
	userGroup: Array<GroupItem> | undefined;
	Selected: number | undefined;
}

export const UserGroupSelect: FC<IUserGroupSelect> = (props) => {
	return (
		<select
			className="borderisgrey"
			name="UserGroup"
			id="SelectedGroup"
			onChange={props.OnChange}
			value={props.Selected}
		>
			{props.userGroup &&
				props.userGroup.map((group) => (
					<UserGroupListItem key={group?.Id.toString()} groupItem={group} />
				))}
		</select>
	);
};

export interface IUserGroupListItemProps {
	groupItem: GroupItem;
}
export const UserGroupListItem: FC<IUserGroupListItemProps> = (props) => {
	return <option value={props.groupItem.Id}>{props.groupItem.Name}</option>;
};
